import Avatar from "@components/profile/avatar";
import {
    IAgoraRTCRemoteUser,
    ICameraVideoTrack,
    IMicrophoneAudioTrack,
    ILocalVideoTrack
} from "agora-rtc-react";
import { useCallback, useEffect, useState } from "react";
import { useWindowSize } from "react-use";
import UserVideoDisplay from "../UserVideoDisplay/userVideoDisplay";
import CurrentUserVideo from "../UserVideo/currentUserVideo";

interface IVideosProps
{
    users: IAgoraRTCRemoteUser[];
    userList: string[];
    tracks: [IMicrophoneAudioTrack, ICameraVideoTrack] | null;
    start: boolean;
    showVideo: boolean;
    myUsername: string;
    shareScreen?: boolean;
    screenTrack?: ILocalVideoTrack;
}

const Videos = (props: IVideosProps) => {
    const {
        users,
        tracks,
        start,
        userList,
        myUsername,
        showVideo,
        shareScreen,
        screenTrack
    } = props;

    const [shownUsers, setShownUsers] = useState<string[][]>([]);
    const { width } = useWindowSize();
    const [showRow, setShowRow] = useState([0, 1]);
    const [maxRows, setMaxRows] = useState(0);

    useEffect(() => {
        if (width >= 1024)
            organizeGroups(4);
        else
            organizeGroups(6);
    }, [userList, width]);

    const ownTrack = useCallback(() => {
        if (shareScreen && screenTrack)
            return screenTrack;
        else if (tracks && tracks.length > 0)
            return tracks[1] as any;
    }, [shareScreen, screenTrack, tracks]);

    const changeRows = (isNext: boolean) => {
        if (isNext) {
            setShowRow(
                showRow.map((eachRow) => eachRow + 1)
            )
        }
        else if (showRow[0] > 0) {
            setShowRow(
                showRow.map((eachRow) => eachRow - 1)
            )
        }
    }

    const organizeGroups = (size: number) => {
        const maxRowsPerSize = Math.ceil(userList.length / (size));
        setMaxRows(maxRowsPerSize);
        const array: string[][] = [];
        for (let i = 0; i < userList.length; i += size) {
            if (i === 0) {
                array.push(userList.slice(i, i + size - 1));
            } else {
                array.push(userList.slice(i, i + size));
            }
        }
        setShownUsers(array);
    }

    const getUsername = (user: string) => {
        if(!user) return "Unknown user";

        return user || "Unknown user";
        // Get username from API
    };

    //This function is used to show or not arrow right based on rows size and responsive with <width> value
    // We use the + 1 value in each validation to compare the exact rows value
    const verifyShowNextPage = useCallback(() => {
        if (width >= 1024) {
            if (maxRows > 2 && maxRows > showRow[1] + 1) {
                return true;
            }
        } else {
            if (maxRows > 1 && maxRows > showRow[0] + 1) {
                return true;
            }
        }
        return false;
    }, [showRow, maxRows, width]);

    const getUser = useCallback((username: string) => {
        const user = users.find(u => u.uid === username);
        return user;
    }, [users, userList]);


    return (
        <div className="VideoCall__Group">
            {showRow[0] > 0 ?
                <em className="fas fa-chevron-left" onClick={() => changeRows(false)} />
                : null}
            {
                shownUsers.length === 0 ?
                    <div className="VideoCall__GroupCtr">
                        {
                            start && tracks && tracks.length > 0 ?
                                <div className="VideoCall__Info">
                                    <div className="VideoCall__Info">
                                        <CurrentUserVideo
                                            videoTrack={ownTrack()}
                                            username={myUsername}
                                            size={120}
                                            showVideo={showVideo} />
                                        <div className="VideoCall__MiniInfoName">
                                            <em className="fas fa-user" />
                                            <p className="VideoCall__MiniInfoNameText"> {getUsername(myUsername)} </p>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                    : null
            }
            {
                width >= 1024 ?
                    shownUsers.map((groupUsers, index) => {
                        return (
                            <div className={showRow.includes(index) ? 'VideoCall__GroupCtr' : 'VideoCall__GroupCtr-Hidden'} key={index}>
                                {
                                    index === 0 ?
                                        start && tracks && tracks.length > 0 ?
                                            <div className="VideoCall__Info">
                                                <div className="VideoCall__Info">
                                                    <CurrentUserVideo
                                                        videoTrack={ownTrack()}
                                                        username={myUsername}
                                                        size={120}
                                                        showVideo={showVideo} />
                                                    <div className="VideoCall__MiniInfoName">
                                                        <em className="fas fa-user" />
                                                        <p className="VideoCall__MiniInfoNameText"> {getUsername(myUsername)} </p>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="VideoCall__Info">
                                                <div className="VideoCall__Avatar">
                                                    <Avatar
                                                        username={myUsername}
                                                        roleCode="PR"
                                                        size={120}
                                                        editable={false}
                                                        />
                                                    <div className="VideoCall__MiniInfoName">
                                                        <em className="fas fa-user" />
                                                        <p className="VideoCall__MiniInfoNameText"> {getUsername(myUsername)} </p>
                                                    </div>
                                                </div>
                                            </div>
                                        :
                                        null
                                }
                                {
                                    groupUsers.length > 0 && groupUsers.map((username) => {
                                        const user = getUser(username);
                                        return (
                                                <UserVideoDisplay
                                                    user={user}
                                                    username={username}
                                                    size={120} />
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                    :
                    shownUsers.map((groupUsers, index) => {
                        return (
                            <div className={showRow[0] === index ? 'VideoCall__GroupCtr' : 'VideoCall__GroupCtr-Hidden'} key={index}>
                                {index === 0 ?
                                    start && tracks && tracks.length > 0 ?
                                        <div className="VideoCall__Info">
                                            <div className="VideoCall__Info">
                                                <CurrentUserVideo
                                                    videoTrack={tracks[1]}
                                                    username={myUsername}
                                                    size={30}
                                                    showVideo={showVideo} />
                                                <div className="VideoCall__MiniInfoName">
                                                    <em className="fas fa-user" />
                                                    <p className="VideoCall__MiniInfoNameText"> {getUsername(myUsername)} </p>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="VideoCall__Info">
                                            <div className="VideoCall__Avatar">
                                                <Avatar
                                                    username={myUsername}
                                                    roleCode="PR"
                                                    size={30}
                                                    editable={false}
                                                />
                                            </div>
                                            <div className="VideoCall__MiniInfoName">
                                                <em className="fas fa-user" />
                                                <p className="VideoCall__MiniInfoNameText"> {getUsername(myUsername)} </p>
                                            </div>
                                        </div>
                                    : null
                                }
                                {groupUsers.length > 0 && groupUsers.map((username) => {
                                    const user = getUser(username);
                                    return (
                                        <UserVideoDisplay
                                            key={username}
                                            user={user}
                                            username={username}
                                            size={60} />
                                    )
                                })}
                            </div>
                        )
                    })
            }
            {verifyShowNextPage() ?
                <em className="fas fa-chevron-right" onClick={() => changeRows(true)} />
                : null}
        </div>
    );
};
export default Videos;